
import CorpSearch from '@/components/Common/UI/Search/CorpSearch'
import Outline from '@/components/Company/Analysis/StockInfo/Outline'
import StockInfo from '@/components/Company/Analysis/StockInfo/'
import StockHistory from '@/components/Company/Analysis/StockHistory/'
import StockThemeChart from '@/components/Company/Analysis/StockThemeChart/'
import { DEFAULT_CODE } from '@/constants/'

import { mapState, mapMutations, mapActions, mapGetters } from 'vuex'

export default {
    name: 'Analysis',
    components: {
        CorpSearch,
        Outline,
        StockInfo,
        StockHistory,
        StockThemeChart,
    },
    props: {
        info: Boolean,
        history: Boolean,
        sector: Boolean,
    },

    // props 변경 시 Warn 발생
    data() {
        return {
            Infoswitch: false,
            Historyswitch: false,
            Sectorswitch: false,
        }
    },
    computed: {
        ...mapState('search', ['corp']),

        // search store에서 변경이 일어나면 변경점 받아서 outline 모듈로 전달
        corpOutline() {
            // console.log(JSON.stringify(this.corp))
            return this.corp
        },
    },

    watch: {
        corp() {
            this.tabFetch()
        },
    },

    created() {
        this.Infoswitch = this.info
        this.Historyswitch = this.history
        this.Sectorswitch = this.sector

        // Default 값
        if (this.corp.code === '') {
            this.SearchInfo(DEFAULT_CODE)
        }
    },

    methods: {
        ...mapActions('search', [
            'GET_CORP_INFO',
            'GET_HISTORY_INFO',
            'GET_THEME_INFO',
            'GET_CORP_PRICE',
            'GET_LUMIT_INFO',
        ]),
        SearchInfo(code) {
            this.GET_CORP_INFO(code)
        },
        SearchHistory(code) {
            this.GET_LUMIT_INFO(code)
        },
        SearchTheme(code) {
            this.GET_THEME_INFO(code)
        },
        SearchCorpPrice(code, limit) {
            const params = {
                code,
                limit,
            }
            this.GET_CORP_PRICE(params)
        },
        onClick(event) {
            this.Infoswitch = false
            this.Historyswitch = false
            this.Sectorswitch = false

            switch (event.target.textContent.trim()) {
                case '종목정보':
                    this.Infoswitch = true
                    this.SearchInfo(this.corp.code)
                    break
                case '종목히스토리':
                    this.Historyswitch = true
                    this.SearchCorpPrice(this.corp.code, 180)
                    this.SearchHistory(this.corp.code)
                    break
                case '종목 테마 차트':
                    this.Sectorswitch = true
                    this.SearchCorpPrice(this.corp.code, 180)
                    this.SearchTheme(this.corp.code)
                    break

                default:
                    break
            }
        },
        tabFetch() {
            if (this.Historyswitch) {
                this.SearchHistory(this.corp.code || DEFAULT_CODE)
                this.SearchCorpPrice(this.corp.code, 180)
            }

            if (this.Sectorswitch) {
                this.SearchTheme(this.corp.code || DEFAULT_CODE)
                this.SearchCorpPrice(this.corp.code, 180)
            }
        },
    },
}
